import { Component, Input, OnInit } from '@angular/core';
import { CNVaccine } from 'src/app/models/cnvaccine';

@Component({
  selector: 'app-vaccine-diseases',
  templateUrl: './vaccine-diseases.component.html',
  styleUrls: ['./vaccine-diseases.component.scss']
})
export class VaccineDiseasesComponent implements OnInit {

  @Input() vaccine: CNVaccine;

  constructor() { }

  ngOnInit(): void {
  }

}
